module.exports = __webpack_public_path__ + "img/straight_line_icon_123.3e09079f.svg";